export const labels = {
	title: {
		label: "Label.MobileCreator.PendingUploadsDialog.Title",
		default: "Uploading photos",
		// description: "Title of a popup when the required action can't be executed because photos are still being uploaded in the background",
		// desktopLabel: "HTML5Editor.Checkout.Title"
	},
	message: {
		general: {
			label: "Label.MobileCreator.PendingUploadsDialog.Message.General",
			default: "Your photos are being uploaded in the background. Please wait.",
			// description: "Message in a popup when the required action can't be executed because photos are still being uploaded in the background",
			// desktopLabel: "HTML5Editor.Checkout.Message" (Desktop label is too long for mobile screens!)
		},
		leavePage: {
			label: "Label.MobileCreator.PendingUploadsDialog.Message.LeavePage",
			default:
				"If you leave this page your photos will stop being uploaded and your unsaved changes will be lost.",
			// description: "Message in a popup when user is trying to leave the edtior while photos are still being uploaded in the background. Unsaved product changed will be lost.",
			// desktopLabel: "Label.HTML5Editor.LeaveLoading.Message"
		},
	},
	returnToProduct: {
		label: "Label.MobileCreator.PendingUploadsDialog.ReturnToProduct",
		default: "Return to product",
		// description: "Short text on button in footer of popup. Popup closes on click. The intented action is aborted and user can continue editing the product.",
		// desktopLabel: "HTML5Editor.Checkout.ReturnToProd" (Desktop label might be a little too long for mobile screens!)
	},
	continue: {
		leavePage: {
			label: "Label.MobileCreator.PendingUploadsDialog.LeavePage",
			default: "Leave page",
			// description: "Short text on button in footer of popup. User is redirected to the requested page on click. Unsaved changes might be lost.",
			// desktopLabel: "Label.HTML5Editor.LeaveLoading.Leave"
		},
		general: undefined,
	},
};
